import { useState, useEffect, useRef, useCallback } from "react";
import { ActionButton, AltButton } from "../../../common/Buttons/Buttons.jsx";
import { Header } from "../../../common/Header/Header.jsx";
import { SelectPerPage } from "../../../common/Forms/Input/Input.jsx";
import { ProvidersPaymentTable } from "../../../common/Tables/Tables.jsx";
import {
  AVProvidersPaymentHeader,
  ProvidersPaymentHeader,
  conciliateTableHeader,
} from "../../../../assets/helpers/tables.js";
import { notify } from "../../../../assets/helpers/toast.js";
import { caseService } from "../../../../services/caseService.js";
import { providersService } from "../../../../services/providersService.js";
import { servicesService } from "../../../../services/servicesService.js";
import { conciliateService } from "../../../../services/conciliateService.js";
import { productService } from "../../../../services/productService";
import { rateService } from "../../../../services/rateService";
import {
  providersPaymentsTypes,
  paymentsSelectionEnum,
} from "../../../../assets/helpers/options.js";
import {
  FilterDatePicker,
  Select,
} from "../../../common/Forms/Input/Input.jsx";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import * as schemas from "../../../../assets/schemas/schemas.js";
import {
  ProdiversPaymentModal,
  ConciliateModal,
  ConciliationSummaryModal,
  ConciliacionMasivaModal,
} from "../../../common/Modals/Modals.jsx";
import { useDropzone } from "react-dropzone";
import {
  capitalize,
  filterParams,
} from "../../../../assets/helpers/funciones.js";
import {
  getProvidersEnum,
  paymentStatusOptions,
  paymentMethods as paymentMethodsEnum,
  IVA,
  caseType,
} from "../../../../assets/helpers/options.js";
import moment from "moment";
import { LoadSpinner } from "../../../common/LoadSpinner/LoadSpinner.jsx";

import "./ProvidersPayment.scss";
import useProvidersPayment from "../../../../hooks/useProvidersPayment.js";

const itemsPerpage = [10, 25, 50, 100, 500, 1000, 2500, 5000];
const paymentMethodsQuantity = [
  { _id: "1", name: "1" },
  { _id: "2", name: "2" },
];

export const FilterButton = (props) => {
  const { label, type, action } = props;

  if (label === type) {
    return <ActionButton label={label} action={() => action(label)} />;
  } else {
    return <AltButton label={label} action={() => action(label)} />;
  }
};

export const ProvidersPayment = () => {
  const { t } = useTranslation();
  const tableRef = useRef(null);

  const [dollarRate, setDollarRate] = useState("");
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [isLoadingPaimentInfo, setIsloadingPaimentInfo] = useState(false);
  const [paid, setPaid] = useState(undefined);
  const [conciled, setConciled] = useState(undefined);
  const [sinceDate, setSinceDate] = useState(new Date());
  const [untilDate, setUntilDate] = useState(new Date());
  const [filterProviders, setFilterProviders] = useState([]);
  const [providersOptions, setProvidersOptions] = useState({
    type: getProvidersEnum?.ROAD_ATTENDANT,
    isInternal: true,
  });

  const [providersPaymentModal, setProvidersPaymentModal] = useState({
    isOpen: false,
    [paymentsSelectionEnum?.PAY]: [],
  });

  const [conciliateModal, setConciliateModal] = useState({
    isOpen: false,
    [paymentsSelectionEnum?.CONCILIATE]: [],
  });

  const [conciliateSummaryModal, setConciliateSummaryModal] = useState(false);

  const [conciliacionMasivaModal, setConciliacionMasivaModal] = useState(false);
  const [conciliacionMasivaFile, setConciliacionMasivaFile] = useState("");
  const [conciliacionMasivaLoading, setConciliacionMasivaLoading] =
    useState(false);
  const conciliacionMasivaSubmittingRef = useRef(false);

  const [uploadedFiles, setUploadedFiles] = useState([null, null]);
  const [showErrorAPI, setShowErrorAPI] = useState(false);

  const { getPaymentsData } = useProvidersPayment()

  const onDrop = useCallback(
    (acceptedFiles, index) => {
      acceptedFiles.forEach((file) => {
        if (
          !["image/png", "image/jpg", "image/jpeg", "application/pdf"].includes(
            file.type
          )
        ) {
          notify(
            "Agregar un formato válido de imagen (PNG, JPG, JPEG)",
            "error"
          );
          return;
        }

        let maxWeight = 5; // MB
        if (file.size * 0.000001 > maxWeight) {
          notify(`La imagen no debe superar los ${maxWeight} MB`, "error");
          return;
        }

        if (index !== undefined && index >= 0 && index < 2) {
          setUploadedFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles[index] = file;
            return newFiles;
          });
          getPaymentsData({
            paymemtMethodOptions: paymentMethods,
            file,
            index,
            watch: watch2,
            setValue: setValue2,
            setIsloading: setIsloadingPaimentInfo,
            methodField: `method${index + 1}`,
            referenceField: `reference${index}`,
            dateField: `date${index}`,
          });
        } else {
          // Fallback if index wasn't correctly passed
          const firstEmptyIndex = uploadedFiles.findIndex((f) => f === null);
          if (firstEmptyIndex !== -1) {
            setUploadedFiles((prevFiles) => {
              const newFiles = [...prevFiles];
              newFiles[firstEmptyIndex] = file;
              return newFiles;
            });
            getPaymentsData({
              paymemtMethodOptions: paymentMethods,
              file,
              index: firstEmptyIndex,
              watch: watch2,
              setValue: setValue2,
              setIsloading: setIsloadingPaimentInfo,
              methodField: `method${firstEmptyIndex + 1}`,
              referenceField: `reference${firstEmptyIndex}`,
              dateField: `date${firstEmptyIndex}`,
            });
          } else {
            notify(
              "Ya se han cargado el número máximo de imágenes (2).",
              "warning"
            );
          }
        }
      });
    },
    [uploadedFiles, paymentMethods]
  );

  const removeFile = (indexToRemove) => {
    setUploadedFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles[indexToRemove] = null;
      return newFiles;
    });
  };

  const [exportablesDataTable, setExportablesDataTable] = useState({
    limit: itemsPerpage[2],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    sinceDate: "",
    untilDate: "",
    isInternal: true,
    isLoading: true,
    type: providersPaymentsTypes?.PAYMENT_AV,
    provider: "",
    paymentStatus: "",
    byMail: false,
  });

  const {
    register,
    errors,
    watch,
    setValue,
    control,
  } = useForm({
    resolver: yupResolver(schemas.conciliateSchema()),
  });

  const {
    register: register2,
    formState: { errors: errors2 },
    handleSubmit: handleSubmit2,
    reset: reset2,
    watch: watch2,
    setValue: setValue2,
    control: control2,
  } = useForm({
    resolver: yupResolver(
      schemas.providerPaymentSchema(
        providersPaymentModal?.totalAmount,
        exportablesDataTable?.type
      )
    ),
  });

  const {
    register: register3,
    formState: { errors: errors3 },
    handleSubmit: handleSubmit3,
    control: control3,
  } = useForm({
    resolver: yupResolver(schemas.conciliateSummarySchema()
    ),
  });


  const validateBillPaymentAmount = (data) => {
    let totalAmount = 0;

    if (
      typeof parseFloat(data?.amount1) === "number" &&
      !isNaN(parseFloat(data?.amount1))
    ) {
      totalAmount += parseFloat(data?.amount1);
    }

    if (
      typeof parseFloat(data?.amount2) === "number" &&
      !isNaN(parseFloat(data?.amount2))
    ) {
      totalAmount += parseFloat(data?.amount2);
    }
    if (
      data?.billNumber &&
      parseFloat(totalAmount?.toFixed(2)) !==
      parseFloat(
        ((providersPaymentModal?.totalAmount * (100 + IVA)) / 100)?.toFixed(2)
      )
    ) {
      notify(
        "b La suma de los montos no coincide con el monto total a pagar",
        "info"
      );
      return false;
    }

    if (
      !data?.billNumber &&
      parseFloat(totalAmount?.toFixed(2)) !==
      parseFloat(providersPaymentModal?.totalAmount?.toFixed(2))
    ) {
      notify(
        "A La suma de los montos no coincide con el monto total a pagar",
        "info"
      );
      return false;
    } else return true;
  };

  const handleAmountChange = (amountIndex) => {
    setValue2(
      `amountBsS${amountIndex}`,
      [providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW].includes(
        exportablesDataTable?.type
      )
        ? (watch2(`amount${amountIndex}`) * watch2("exchangeRate")).toFixed(2)
        : (watch2(`amount${amountIndex}`) * dollarRate).toFixed(2)
    );

    if (amountIndex === "1" && !watch2("billNumber")) {
      setValue2(
        `amount2`,
        (
          providersPaymentModal?.totalAmount - parseFloat(watch2(`amount1`))
        )?.toFixed(2)
      );
      setValue2(
        `amountBsS2`,
        [providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW].includes(
          exportablesDataTable?.type
        )
          ? (watch2(`amount${amountIndex}`) * watch2("exchangeRate")).toFixed(2)
          : (watch2(`amount${amountIndex}`) * dollarRate).toFixed(2)
      );
    }
    if (amountIndex === "1" && watch2("billNumber")) {
      setValue2(
        `amount2`,
        (
          (providersPaymentModal?.totalAmount * (100 + IVA)) / 100 -
          parseFloat(watch2(`amount1`))
        )?.toFixed(2)
      );
      setValue2(
        `amountBsS2`,
        [providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW].includes(
          exportablesDataTable?.type
        )
          ? (watch2(`amount${amountIndex}`) * watch2("exchangeRate")).toFixed(2)
          : (watch2(`amount${amountIndex}`) * dollarRate).toFixed(2)
      );
    }
  };

  // code the logic to receive payment evidence file

  const handleMethodsChange = () => {
    setValue2(`amount2`, 0);
    setValue2(`amountBsS2`, 0);
    setValue2(`method2`, "");
    setValue2(`reference2`, "");
    removeFile(1);
  };

  const handleProviderMethodChange = (slotIndex) => {
    setValue2(`skipApiValidationError${slotIndex}`, false);
  };

  const appendFile = (data) => {
    const formData = new FormData();

    formData.append("providerId", data?.providerId);
    formData.append("providerPaidDate", data?.providerPaidDate);
    if (data?.billNumber) formData.append("billNumber", data?.billNumber);
    if (data?.observation) formData.append("observation", data?.observation);

    data?.services.forEach((service, index) => {
      formData.append(`services[${index}][_id]`, service?._id);
      formData.append(`services[${index}][code]`, service?.code);
      formData.append(`services[${index}][amount]`, service?.amount);
      formData.append(`services[${index}][amountBsS]`, service?.amountBsS);
    });

    data?.paymentData.forEach((payment, index) => {
      formData.append(`paymentData[${index}][method]`, payment?.method);
      formData.append(`paymentData[${index}][amount]`, payment?.amount);
      formData.append(`paymentData[${index}][amountBs]`, payment?.amountBs);
      if (payment?.reference)
        formData.append(`paymentData[${index}][reference]`, payment?.reference);
      const slotIndex = index + 1;
      if (showErrorAPI && watch2(`skipApiValidationError${slotIndex}`)) {
        formData.append(
          `paymentData[${index}][skipApiValidationError]`,
          watch2(`skipApiValidationError${slotIndex}`)
        );
      }
    });

    if (data?.paymentEvidence.length > 0) {
      data?.paymentEvidence.forEach((evidence, index) => {
        formData.append(`paymentEvidence`, evidence);
      });
    }

    return formData;
  };

  const createProviderPayment = handleSubmit2(async (data) => {
    if (
      [providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW].includes(
        exportablesDataTable?.type
      )
    ) {
      if (!data?.reference0 || (data?.reference0 && !uploadedFiles[0])) {
        notify(
          "Debe agregar un comprobante para el primer método de pago",
          "error"
        );
        return null;
      }
      console.log('uploadedFiles', uploadedFiles);
      if (
        (data.providerMethods > 1 && !data?.reference1) ||
        (data.providerMethods > 1 && data?.reference1 && !uploadedFiles[1])
      ) {
        notify(
          "Debe agregar un comprobante para el segundo método de pago",
          "error"
        );
        return null;
      }
    }

    if (!validateBillPaymentAmount(data)) {
      return null;
    }
    let services = [];
    let paymentData = [];

    for (let i = 0; i < data.providerMethods; i++) {
      paymentData?.push({
        method: data[`method${i + 1}`],
        amount: data[`amount${i + 1}`],
        amountBs: data[`amountBsS${i + 1}`],
        reference: data[`reference${i}`],
      });
    }
    const paymentEvidence = uploadedFiles.filter((file) => file !== null);

    for (let i = 0; i < providersPaymentModal?.data?.length; i++) {
      services.push({
        _id: providersPaymentModal?.data[i]?._id,
        code: providersPaymentModal?.data[i]?.code,
        amount: providersPaymentModal?.data[i]?.providerPay,
        amountBsS: [providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW].includes(
          exportablesDataTable?.type
        )
          ? (
            providersPaymentModal?.data[i]?.providerPay *
            watch2("exchangeRate")
          ).toFixed(2)
          : (providersPaymentModal?.data[i]?.providerPay * dollarRate).toFixed(
            2
          ),
      });
    }

    let dataToPost = {
      observation: data?.observation,
      billNumber: data?.billNumber,
      services: services,
      providerId: providersPaymentModal?.data[0]?.providerId,
      paymentData,
      paymentEvidence,
      providerPaidDate: data?.providerPaidDate
        ? data?.providerPaidDate
        : new Date(),
    };

    const postData = appendFile(dataToPost);

    if (!isLoading && postData) {
      setIsloading(true);
      providersService
        .payProviders(postData)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Pago realizado`, "success");
            getExportables(exportablesDataTable?.type);
            handlePaymentModal();
            reset2();
            setUploadedFiles([]);
            setIsloading(false);
          } else {
            setShowErrorAPI(true);
            notify(
              `${response?.data?.message || response?.message || "No pudimos validar el pago, por favor revisa los datos ingresados"}`,
              "error"
            );
            setIsloading(false);
          }
        })
        .catch(() => {
          setShowErrorAPI(true);
          setIsloading(false);
        });
    }
  });

  const getDollarRate = () => {
    rateService
      .getDollarRate()
      .then((response) => {
        if (response.status === 200) {
          setDollarRate(response?.data?.rate);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch(() => { });
  };

  const getDollarRateByDate = () => {
    let params = {
      currency: "USD",
      date: watch2("providerPaidDate")
        ? moment(watch2("providerPaidDate")).format("YYYY-MM-DD")
        : "",
      limit: 1,
    };

    rateService
      .getCurrencyRates(params)
      .then((response) => {
        if (response.status === 200) {
          let rate = response?.data?.result[0]?.rate;
          setValue2("exchangeRate", rate);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch(() => { });
  };

  const selectType = (type) => {
    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        provider: "",
      };
    });

    if (type === providersPaymentsTypes?.PAYMENT_AV) {
      setProvidersOptions((prevState) => {
        return {
          ...prevState,
          type: getProvidersEnum?.ROAD_ATTENDANT,
          isInternal: true,
        };
      });
    }
    if (type === providersPaymentsTypes?.PAYMETN_INTERNAL_TOW) {
      setProvidersOptions((prevState) => {
        return {
          ...prevState,
          type: getProvidersEnum?.CRANE,
          isInternal: true,
        };
      });
    }
    if (type === providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW) {
      setProvidersOptions((prevState) => {
        return {
          ...prevState,
          type: getProvidersEnum?.CRANE,
          isInternal: false,
        };
      });
    }

    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        type: type,
      };
    });
  };

  const handleSinceDateChange = (e) => {
    if (e > untilDate) {
      notify("Ingrese una fecha en un rago valido ", "info");
    } else {
      setSinceDate(e);
    }
  };
  const handleUntilDateChange = (e) => {
    if (e < sinceDate) {
      notify("Ingrese una fecha en un rago valido ", "info");
    } else {
      setUntilDate(e);
    }
  };

  const selectitemsPerpage = (event) => {
    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * exportablesDataTable?.limit,
      };
    });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  function getExportables(type, byMail) {
    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    let body = {
      sinceDate: moment(sinceDate).format("YYYY-MM-DD"),
      untilDate: moment(untilDate).format("YYYY-MM-DD"),
      limit: exportablesDataTable?.limit,
      page: exportablesDataTable?.page,
      type: type ? type : exportablesDataTable?.type,
      providers: exportablesDataTable?.provider,
      paymentStatus: exportablesDataTable?.paymentStatus,
    };
    if (byMail === true) {
      body.byMail = true;
      body.providerView = true;
    }

    if ([providersPaymentsTypes?.PAYMENT_AV].includes(type)) {
      if (body.providers === "") {
        delete body.providers;
      } else {
        let provider = [];
        provider.push(body.providers);
        body.providers = provider;
      }
      if (body.paymentStatus === "") {
        delete body.paymentStatus;
      }
      delete body.type;

      caseService
        .getAVPayments(body)
        .then((response) => {
          if (response.status === 200) {
            if (byMail) {
              notify("El exportable se ha enviado por correo", "success");
              setExportablesDataTable((prevState) => {
                return {
                  ...prevState,
                  isLoading: false,
                  byMail: false,
                };
              });
            } else {
              setExportablesDataTable((prevState) => {
                let data = [...exportablesDataTable?.data];
                if (
                  [
                    providersPaymentsTypes?.PAYMETN_INTERNAL_TOW,
                    providersPaymentsTypes?.PAYMENT_AV,
                    providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW,
                  ].includes(type)
                ) {
                  data = response?.data?.services;
                }

                for (let i = 0; i < data?.length; i++) {
                  data[i][paymentsSelectionEnum?.PAY] = false;
                  data[i][paymentsSelectionEnum?.CONCILIATE] = false;
                }

                return {
                  ...prevState,
                  data: data,
                  count: response?.data?.count,
                  isLoading: false,
                };
              });
            }
          } else {
            notify(`${response.message}` || "error", "error");
            setExportablesDataTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }
        })
        .catch(() => {
          setExportablesDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        });
    }

    if ([providersPaymentsTypes?.PAYMETN_INTERNAL_TOW].includes(type)) {
      body.paymentStatus = paid;
      body.reconciled = conciled;

      if (body.reconciled === null) {
        delete body.reconciled;
      }
      if (body.paymentStatus === "") {
        delete body.paymentStatus;
      }
      if (body.providers === "") {
        delete body.providers;
      } else {
        let provider = [];
        provider.push(body.providers);
        body.providers = provider;
      }
      delete body.type;
      caseService
        .getInternalTowsPayments(body)
        .then((response) => {
          if (response.status === 200) {
            if (byMail) {
              notify("El exportable se ha enviado por correo", "success");
              setExportablesDataTable((prevState) => {
                return {
                  ...prevState,
                  isLoading: false,
                  byMail: false,
                };
              });
            } else {
              setExportablesDataTable((prevState) => {
                let data = [...exportablesDataTable?.data];
                if (
                  [
                    providersPaymentsTypes?.PAYMETN_INTERNAL_TOW,
                    providersPaymentsTypes?.PAYMENT_AV,
                    providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW,
                  ].includes(type)
                ) {
                  data = response?.data?.services;
                }

                for (let i = 0; i < data?.length; i++) {
                  data[i][paymentsSelectionEnum?.PAY] = false;
                  data[i][paymentsSelectionEnum?.CONCILIATE] = false;
                }

                return {
                  ...prevState,
                  data: data,
                  count: response?.data?.count,
                  isLoading: false,
                };
              });
            }
          } else {
            notify(`${response.message}` || "error", "error");
            setExportablesDataTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }
        })
        .catch(() => {
          setExportablesDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        });
    }

    if ([providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW].includes(type)) {
      body.providers = filterProviders;
      body.paymentStatus = paid;
      body.reconciled = conciled;
      delete body.type;
      caseService
        .getExternalTowsPayments(body)
        .then((response) => {
          if (response.status === 200) {
            if (byMail) {
              notify("El exportable se ha enviado por correo", "success");
              setExportablesDataTable((prevState) => {
                return {
                  ...prevState,
                  isLoading: false,
                  byMail: false,
                };
              });
            } else {
              setExportablesDataTable((prevState) => {
                let data = [...exportablesDataTable?.data];
                if (
                  [
                    providersPaymentsTypes?.PAYMETN_INTERNAL_TOW,
                    providersPaymentsTypes?.PAYMENT_AV,
                    providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW,
                  ].includes(type)
                ) {
                  data = response?.data?.services;
                }

                for (let i = 0; i < data?.length; i++) {
                  data[i][paymentsSelectionEnum?.PAY] = false;
                  data[i][paymentsSelectionEnum?.CONCILIATE] = false;
                }

                return {
                  ...prevState,
                  data: data,
                  count: response?.data?.count,
                  isLoading: false,
                };
              });
            }
          } else {
            notify(`${response.message}` || "error", "error");
            setExportablesDataTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }
        })
        .catch(() => {
          setExportablesDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        });
    }

    // caseService
    //   .getExportables(filterParams(body))
    //   .then(response => {
    //     if (response.status === 200) {
    //       setExportablesDataTable(prevState => {
    //         let data = [...exportablesDataTable?.data];
    //         if (
    //           [
    //             providersPaymentsTypes?.PAYMETN_INTERNAL_TOW,
    //             providersPaymentsTypes?.PAYMENT_AV,
    //             providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW,
    //           ].includes(body?.type)
    //         ) {
    //           data = response?.data?.services;
    //         }

    //         for (let i = 0; i < data?.length; i++) {
    //           data[i][paymentsSelectionEnum?.PAY] = false;
    //           data[i][paymentsSelectionEnum?.CONCILIATE] = false;
    //         }

    //         return {
    //           ...prevState,
    //           data: data,
    //           count: response?.data?.count,
    //           isLoading: false,
    //         };
    //       });
    //     } else {
    //       notify(`${response.message}` || 'error', 'error');
    //       setExportablesDataTable(prevState => {
    //         return {
    //           ...prevState,
    //           isLoading: false,
    //         };
    //       });
    //     }
    //   })
    //   .catch(() => {
    //     setExportablesDataTable(prevState => {
    //       return {
    //         ...prevState,
    //         isLoading: false,
    //       };
    //     });
    //   });
    return true;
  }

  const conciliate = () => {
    let dataToPost = [];

    for (let i = 0; i < conciliateModal?.conciliate?.length; i++) {
      dataToPost.push(conciliateModal?.conciliate[i]?._id);
    }

    if (!isLoading) {
      setIsloading(true);
      servicesService
        .conciliateService(
          filterParams({ ids: dataToPost, paymentDate: watch("paymentDate") })
        )
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            getExportables(exportablesDataTable?.type);
            notify(`Conciliación realizada`, "success");
            handleConciliateModal();
            setIsloading(false);
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch(() => {
          setIsloading(false);
        });
    }
  };

  const reconciliate = handleSubmit3(async (data) => {

    if (!isLoading) {
      setIsloading(true);
      conciliateService
        .reconciliateDate(
          filterParams({ reconciledDate: moment(data?.reconciledDate).format("YYYY-MM-DD"), byMail: true })
        )
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Correo enviado`, "success");
            handleConciliateSummaryModal();
            setIsloading(false);
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch(() => {
          setIsloading(false);
        });
    }
  });

  const handleMultiplePayments = (value, name) => {
    let data = [...exportablesDataTable?.data];

    for (let i = 0; i < data?.length; i++) {
      if (
        data[i]?.providerName === name &&
        data[i]?.providerPaymentStatus !== "Pagado"
      ) {
        data[i][paymentsSelectionEnum?.PAY] = value;
      }
    }
    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        data: data,
      };
    });
  };

  const advisorListOptions = (arr) => {
    let advisors = [];
    arr?.sort((a, b) => {
      if (a?.name === "" || b?.name === "") {
        return 0;
      }
      if (a?.name < b?.name) {
        return -1;
      }
      if (a?.name > b?.name) {
        return 1;
      }
      return 0;
    });

    if (arr) {
      for (let i = 0; i < arr?.length; i++) {
        advisors.push({
          _id: arr[i]?._id,
          name: capitalize(arr[i]?.name),
        });
      }
    }
    return advisors;
  };

  const handleFilterProviderOptions = (arr) => {
    arr = arr.filter((item) => item !== "");
    setFilterProviders(arr);
  };

  const handlePaidOptions = (arr) => {
    console.log(arr);
    if (arr.length > 0) {
      let paid = arr.includes("Pagado");
      let pending = arr.includes("No pagado");
      if (paid && pending) {
        setPaid("");
      } else if (paid) {
        setPaid("Pagado");
      } else if (pending) {
        setPaid("No pagado");
      }
    } else {
      setPaid("");
    }
  };

  const handleConciledOptions = (arr) => {
    if (arr.length > 0) {
      let paid = arr.includes("Conciliado");
      let pending = arr.includes("No conciliado");
      if (paid && pending) {
        setConciled(null);
      } else if (paid) {
        setConciled(true);
      } else if (pending) {
        setConciled(false);
      }
    } else {
      setConciled(null);
    }
  };

  const handleMultipleConciliation = (value, name) => {
    let data = [...exportablesDataTable?.data];

    for (let i = 0; i < data?.length; i++) {
      if (data[i]?.providerName === name && !data[i]?.providerReconciled) {
        data[i][paymentsSelectionEnum?.CONCILIATE] = value;
      }
    }
    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        data: data,
      };
    });
  };

  const selectPayment = (payment, index) => {
    let datos = [...exportablesDataTable?.data];
    datos[index][paymentsSelectionEnum?.PAY] =
      !datos[index][paymentsSelectionEnum?.PAY];

    let none = "";

    for (let i = 0; i < datos.length; i++) {
      if (datos[i][paymentsSelectionEnum?.PAY]) {
        none = payment?.status;
      }
    }

    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        data: datos,
        selectedType: none,
      };
    });
  };

  const selectConciliate = (payment, index) => {
    let datos = [...exportablesDataTable?.data];
    datos[index][paymentsSelectionEnum?.CONCILIATE] =
      !datos[index][paymentsSelectionEnum?.CONCILIATE];

    let none = "";

    for (let i = 0; i < datos.length; i++) {
      if (datos[i][paymentsSelectionEnum?.CONCILIATE]) {
        none = payment?.status;
      }
    }

    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        data: datos,
        selectedType: none,
      };
    });
  };

  const getPaymentMethods = () => {
    productService
      .getPaymentMethods("operations")
      .then((response) => {
        if (response.status === 200) {
          let filteredMethods = response.data?.filter((p) =>
            [
              paymentMethodsEnum?.PAGO_MÓVIL,
              paymentMethodsEnum?.ZELLE,
              paymentMethodsEnum?.CASH,
              paymentMethodsEnum?.TRANSFERENCIA_BANESCO,
              paymentMethodsEnum?.PAGO_MÓVIL_BANCAMIGA,
              paymentMethodsEnum?.TRANSFERENCIA_BANCAMIGA,
              paymentMethodsEnum?.PAGO_MÓVIL_BNC,
              paymentMethodsEnum?.PAYPAL,
              paymentMethodsEnum?.CASH_USD,
            ]?.includes(p?.name)
          );

          setPaymentMethods(filteredMethods);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const getSelectedpayments = () => {
    let pay = exportablesDataTable?.data?.filter(
      (p) => p[paymentsSelectionEnum?.PAY]
    );
    return pay;
  };

  const getConciliatedpayments = () => {
    let pay = exportablesDataTable?.data?.filter(
      (p) => p[paymentsSelectionEnum?.CONCILIATE]
    );
    return pay;
  };

  const handlePaymentModal = () => {
    const pay = getSelectedpayments();
    let totalAmount = 0;

    let particularPayment = 0;
    let affiliatedPayment = 0;

    for (let i = 0; i < pay.length; i++) {
      if (pay[i]?.caseType === caseType?.PARTICULAR) {
        particularPayment = particularPayment + pay[i]?.providerPay;
      }

      if (pay[i]?.caseType === caseType?.AFFILIATED) {
        affiliatedPayment = affiliatedPayment + pay[i]?.providerPay;
      }
    }

    for (let i = 0; i < pay.length; i++) {
      totalAmount = totalAmount + pay[i]?.providerPay;
    }

    setProvidersPaymentModal((prevState) => {
      return {
        ...prevState,
        data: providersPaymentModal?.isOpen ? [] : pay,
        isOpen: !providersPaymentModal?.isOpen,
        totalAmount: totalAmount,
        particularPayment: parseFloat(particularPayment.toFixed(2)),
        affiliatedPayment: parseFloat(affiliatedPayment.toFixed(2)),
      };
    });
    const [cash] = paymentMethods?.filter(
      (p) => p?.name === paymentMethodsEnum?.CASH_USD
    );
    const [pagoMovil] = paymentMethods?.filter(
      (p) => p?.name === paymentMethodsEnum?.PAGO_MÓVIL_BANCAMIGA
    );
    reset2({
      providerMethods: 2,
      method1: cash?._id || "",
      method2: pagoMovil?._id || "",
    });
  };

  const handleConciliateModal = () => {
    const today = new Date();
    const nextWednesday = new Date(today);
    nextWednesday.setDate(
      today.getDate() + ((3 - today.getDay() + 7) % 7 || 7)
    );
    setValue("paymentDate", nextWednesday);
    const conciliate = getConciliatedpayments();
    setConciliateModal((prevState) => {
      return {
        ...prevState,
        [paymentsSelectionEnum?.CONCILIATE]: providersPaymentModal?.isOpen
          ? []
          : conciliate,
        isOpen: !conciliateModal?.isOpen,
      };
    });
  };

  const handleConciliateSummaryModal = () => {
    setConciliateSummaryModal(!conciliateSummaryModal);
  };

  const onDropConciliacionMasiva = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      if (
        ![
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ].includes(file.type)
      ) {
        notify("Por favor, sube un archivo de Excel (.xlsx o .xls)", "error");
        return;
      }

      const maxWeight = 5;
      if (file.size * 0.000001 > maxWeight) {
        notify(
          `El archivo de Excel no debe superar los ${maxWeight} MB`,
          "error"
        );
        return;
      }

      setConciliacionMasivaFile(file);
    });
  }, []);

  const { getRootProps: getConciliacionMasivaRootProps, getInputProps: getConciliacionMasivaInputProps } =
    useDropzone({
      onDrop: onDropConciliacionMasiva,
      disabled: conciliacionMasivaLoading,
    });

  const handleConciliacionMasivaModal = () => {
    if (conciliacionMasivaSubmittingRef.current) return;

    if (conciliacionMasivaModal) {
      setConciliacionMasivaFile("");
    }
    setConciliacionMasivaModal(!conciliacionMasivaModal);
  };

  const uploadConciliacionMasiva = () => {
    if (conciliacionMasivaSubmittingRef.current) return;

    conciliacionMasivaSubmittingRef.current = true;
    setConciliacionMasivaLoading(true);

    const formData = new FormData();
    formData.append("fileName", "conciliationFile");
    formData.append("reconcilingFile", conciliacionMasivaFile);

    servicesService
      .reconcileFile(formData)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          if (response?.data?.fileErrors) {
            notify(
              "El archivo contiene errores, se han actualizado solo los datos correctos",
              "error"
            );

            const link = document.createElement("a");
            link.href = response?.data?.fileErrors?.file;
            link.setAttribute("download", "conciliacion.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            notify("Conciliación masiva realizada con éxito", "success");
          }

          handleConciliacionMasivaModal();
          getExportables(exportablesDataTable?.type);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => {
        notify("Error al procesar la conciliación masiva", "error");
      })
      .finally(() => {
        conciliacionMasivaSubmittingRef.current = false;
        setConciliacionMasivaLoading(false);
      });
  };

  const exportTable = () => {
    setExportablesDataTable((prevState) => {
      return {
        ...prevState,
        isLoading: false,
        byMail: true,
      };
    });

    getExportables(exportablesDataTable?.type, true);
  };

  const getProviders = () => {
    let params = {
      type: providersOptions?.type,
      offset: 0,
      limit: 10000,
      isInternal: providersOptions?.isInternal,
      // isActive: true,
    };

    setProvidersOptions((prevState) => {
      return {
        ...prevState,
        data: [],
        count: 0,
        isLoading: false,
      };
    });

    providersService
      .getProvidersByType(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          setProvidersOptions((prevState) => {
            return {
              ...prevState,
              data: [{ _id: "", name: "" }, ...response?.data?.providers],
              count: response?.data?.count,
              isLoading: false,
            };
          });
        }
      })
      .catch(() => { });
    return true;
  };

  const handleHeaderFilters = () => {
    ProvidersPaymentHeader.forEach((header) => {
      if (header.name === "Empresa/Chofer") {
        header.filterOptions = advisorListOptions(providersOptions?.data);
        header.filterSearch = handleFilterProviderOptions;
        header.sortable = true;
      }
    });
  };

  useEffect(() => {
    handleHeaderFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportablesDataTable?.type, providersOptions]);

  useEffect(() => {
    getDollarRate();
    getPaymentMethods();
    getExportables(exportablesDataTable?.type);
    getProviders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    exportablesDataTable?.page,
    exportablesDataTable?.offset,
    exportablesDataTable?.limit,
    exportablesDataTable?.type,
    exportablesDataTable?.sinceDate,
    exportablesDataTable?.untilDate,
    exportablesDataTable?.provider,
    exportablesDataTable?.paymentStatus,
    sinceDate,
    untilDate,
    paid,
    conciled,
    filterProviders,
  ]);

  useEffect(() => {
    getProviders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    exportablesDataTable?.page,
    exportablesDataTable?.offset,
    exportablesDataTable?.limit,
    exportablesDataTable?.type,
    sinceDate,
    untilDate,
    paid,
    conciled,
    filterProviders,
    providersOptions?.type,
    providersOptions?.isInternal,
  ]);

  useEffect(() => {
    getDollarRateByDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch2("providerPaidDate")]);

  return (
    <>
      <LoadSpinner show={exportablesDataTable.isLoading} />
      <LoadSpinner show={isLoadingPaimentInfo} />
      <LoadSpinner show={conciliacionMasivaLoading} />
      <Header />
      <ProdiversPaymentModal
        modal={providersPaymentModal}
        handleModal={handlePaymentModal}
        options={{
          paymentMethodsQuantity: paymentMethodsQuantity,
          paymentMethods: paymentMethods,
        }}
        onChange={{
          handleAmountChange: handleAmountChange,
          handleMethodsChange: handleMethodsChange,
          handleProviderMethodChange: handleProviderMethodChange,
        }}
        register={register2}
        errors={errors2}
        watch={watch2}
        action={createProviderPayment}
        control={control2}
        type={exportablesDataTable?.type}
        fileUploaded={uploadedFiles}
        onDrop={onDrop}
        removeFile={removeFile}
        showErrorAPI={showErrorAPI}
      />
      <ConciliateModal
        modal={conciliateModal}
        handleModal={handleConciliateModal}
        register={register}
        errors={errors}
        control={control}
        action={conciliate}
        conciliateTableHeader={conciliateTableHeader}
      />
      <ConciliationSummaryModal
        modal={conciliateSummaryModal}
        handleModal={handleConciliateSummaryModal}
        register={register3}
        errors={errors3}
        control={control3}
        action={reconciliate}
      />
      <ConciliacionMasivaModal
        show={conciliacionMasivaModal}
        handleCloseModal={handleConciliacionMasivaModal}
        fileUploaded={conciliacionMasivaFile}
        setFileUploaded={setConciliacionMasivaFile}
        getRootProps={getConciliacionMasivaRootProps}
        getInputProps={getConciliacionMasivaInputProps}
        upload={uploadConciliacionMasiva}
        isLoading={conciliacionMasivaLoading}
        message="Arrastrar o buscar documento"
      />
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">
            TU/GRUERO: {exportablesDataTable?.count}
          </h1>
          <div className="buttons-container">

            {exportablesDataTable?.type === providersPaymentsTypes?.PAYMETN_INTERNAL_TOW &&
              <ActionButton label={"Resumen de Conciliación"} action={() => handleConciliateSummaryModal()} />
            }

            {[
              providersPaymentsTypes?.PAYMETN_INTERNAL_TOW,
              providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW,
            ].includes(exportablesDataTable?.type) && (
                <ActionButton
                  label={"Conciliación masiva"}
                  action={() => handleConciliacionMasivaModal()}
                />
              )}

            <ActionButton label={"Exportar"} action={() => exportTable()} />
          </div>
        </div>
        <div className="breadcrumb-container">
          <div className="exportables-buttons-container">
            <FilterButton
              label={providersPaymentsTypes?.PAYMENT_AV}
              type={exportablesDataTable?.type}
              action={selectType}
            />
            <FilterButton
              label={providersPaymentsTypes?.PAYMETN_INTERNAL_TOW}
              type={exportablesDataTable?.type}
              action={selectType}
            />
            <FilterButton
              label={providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW}
              type={exportablesDataTable?.type}
              action={selectType}
            />
          </div>
          <div className="exportables-buttons-container">
            <FilterDatePicker
              bootstrap={"col-4"}
              label={"Desde"}
              type={"date"}
              name={"untilDate"}
              placeholder={""}
              onChange={handleSinceDateChange}
              value={sinceDate}
            />{" "}
            <FilterDatePicker
              bootstrap={"col-4"}
              label={"Hasta"}
              type={"date"}
              name={"untilDate"}
              placeholder={""}
              onChange={handleUntilDateChange}
              value={untilDate}
            />
            <div className="col-6 providers-payments-filter-container">
              {exportablesDataTable?.type !==
                providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW && (
                  <>
                    <Select
                      options={providersOptions?.data}
                      label={"Proveedores"}
                      value={exportablesDataTable?.provider}
                      name={"provider"}
                      onChange={handleFilterChange}
                    />
                    <Select
                      options={paymentStatusOptions}
                      label={"Estatus de pago"}
                      value={exportablesDataTable?.paymentStatus}
                      name={"paymentStatus"}
                      onChange={handleFilterChange}
                    />
                  </>
                )}
              <div style={{ width: "24px" }}>
                <SelectPerPage
                  label={"Registros"}
                  options={itemsPerpage}
                  value={exportablesDataTable?.limit}
                  onChange={selectitemsPerpage}
                />
              </div>
            </div>
          </div>
          <span></span>
        </div>
        {getSelectedpayments().length > 0 && (
          <div style={{ marginBottom: "12px" }}>
            <ActionButton label={"Pagar"} action={() => handlePaymentModal()} />
          </div>
        )}
        {getConciliatedpayments().length > 0 && (
          <div style={{ marginBottom: "12px" }}>
            <ActionButton
              label={"Conciliar"}
              action={() => handleConciliateModal()}
            />
          </div>
        )}

        {[
          providersPaymentsTypes?.PAYMENT_AV,
          providersPaymentsTypes?.PAYMETN_INTERNAL_TOW,
          providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW,
        ].includes(exportablesDataTable?.type) &&
          !exportablesDataTable.isLoading && (
            <ProvidersPaymentTable
              header={
                [providersPaymentsTypes?.PAYMENT_AV].includes(
                  exportablesDataTable?.type
                )
                  ? AVProvidersPaymentHeader
                  : ProvidersPaymentHeader
              }
              handlePageChange={handlePageChange}
              selectPayment={selectPayment}
              selectConciliate={selectConciliate}
              data={exportablesDataTable}
              type={exportablesDataTable?.type}
              tableRef={tableRef}
              handleMultiplePayments={handleMultiplePayments}
              handleMultipleConciliation={handleMultipleConciliation}
              paid={handlePaidOptions}
              conciliated={handleConciledOptions}
            />
          )}
      </div>
    </>
  );
};
